import { Component, Host, Input } from '@angular/core';

import { UICheckboxGroupComponent } from '../ui-checkbox-group/ui-checkbox-group.component';

@Component({
  selector: 'app-ui-checkbox-group-item',
  templateUrl: './ui-checkbox-group-item.component.html',
  styleUrls: ['./ui-checkbox-group-item.component.scss'],
  standalone: false
})
export class UICheckboxGroupItemComponent {
  @Input() value: string | number;

  constructor(@Host() public uiCheckboxGroup: UICheckboxGroupComponent) {}
}
